import { IconWrapper } from '../runtime';
export default IconWrapper('dbs_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#00A692"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#009080"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#0BBEA8"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#00A692"
    }
  }), h("path", {
    "attrs": {
      "d": "M6.83576 4.91675L2.4375 6.34584L4.04364 8.36099L8.44189 6.9319L10.048 8.94705L14.4463 7.51796L12.8402 5.50281L8.44189 6.9319L6.83576 4.91675Z",
      "fill": "white"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.32697 9.41251L3.92871 10.8416L5.53485 12.8567L9.93311 11.4277L11.5392 13.4428L15.9375 12.0137L14.3314 9.99857L9.93311 11.4277L8.32697 9.41251Z",
      "fill": "white"
    }
  })]);
});